import { render } from "./ContactInfoPreview.vue?vue&type=template&id=70876a1a&scoped=true"
import script from "./ContactInfoPreview.vue?vue&type=script&lang=js"
export * from "./ContactInfoPreview.vue?vue&type=script&lang=js"

import "./ContactInfoPreview.vue?vue&type=style&index=0&id=70876a1a&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70876a1a"]])

export default __exports__